// material-ui
import { alpha, styled } from '@mui/material/styles';

// third-party
import SimpleBar, { Props } from 'simplebar-react';
import { MUIStyledCommonProps } from '@mui/system';
import { ReactNode } from 'react';
import { Theme } from '@mui/material';

// scroll bar wrapper
//
// The template branched on `react-device-detect` and rendered a plain overflow box on mobile.
// SimpleBar already leaves touch scrolling to the browser, so the branch bought a dependency and
// a second code path for nothing.
const SimpleBarStyle = styled(SimpleBar)(({ theme }) => ({
  maxHeight: '100%',
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.25)
    },
    '&.simplebar-visible:before': {
      opacity: 1
    }
  },
  '& .simplebar-track.simplebar-vertical': {
    width: 10
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    height: 6
  },
  '& .simplebar-mask': {
    zIndex: 'inherit'
  }
}));

// ==============================|| SIMPLE SCROLL BAR  ||============================== //

export default function SimpleBarScroll({ children, sx, ...other }: MUIStyledCommonProps<Theme> & Props) {
  return (
    <SimpleBarStyle clickOnTrack={false} sx={{ flexGrow: 1, height: '100%', ...sx }} {...other}>
      {children as ReactNode}
    </SimpleBarStyle>
  );
}
